import { useState } from "react";
import Modal from "../LancarComissao/Modal";
import "./ListaUsuarios.css";

const ListaUsuarios = ({ lista = [], onEdit, onToggleStatus }) => {
  const [confirmacao, setConfirmacao] = useState(null);
  const [processando, setProcessando] = useState(false);

  const itens = lista;

  const renderizarStatus = (status) => {
    switch (String(status || "").toUpperCase()) {
      case "ACTIVE":
        return <span className="status-pill status-ativo">Ativo</span>;
      case "INACTIVE":
        return <span className="status-pill status-inativo">Inativo</span>;
      default:
        return <span className="status-pill">-</span>;
    }
  };

  const formatarDataBR = (data) => {
    if (!data) return "-";
    return new Intl.DateTimeFormat("pt-BR").format(new Date(data));
  };

  const abrirConfirmacao = (item) => {
    const statusAtual = String(item?.status || "").toUpperCase();
    const proximoStatus = statusAtual === "INACTIVE" ? "ACTIVE" : "INACTIVE";
    setConfirmacao({ item, proximoStatus });
  };

  const fecharConfirmacao = () => {
    if (processando) return;
    setConfirmacao(null);
  };

  const confirmarTrocaStatus = async () => {
    if (!confirmacao?.item || !onToggleStatus) return;

    try {
      setProcessando(true);
      await onToggleStatus(confirmacao.item);
      setConfirmacao(null);
    } catch (err) {
      alert(err?.message || "Nao foi possivel atualizar o status.");
    } finally {
      setProcessando(false);
    }
  };

  return (
    <section className="table-card">
      <div className="title-list">
        Admin pode <strong>cadastrar e editar licenciados</strong>, alem de acessar <strong>extrato</strong> e
        <strong> dados bancarios</strong> de cada usuario.
      </div>

      <div className="tablela">
        <table>
          <thead>
            <tr>
              <th>Nome do licenciado</th>
              <th>E-mail de acesso</th>
              <th>Status</th>
              <th>Data de criacao</th>
              <th>Acoes</th>
            </tr>
          </thead>

          <tbody id="usuariosTableBody">
            {itens.map((item) => {
              const isInativo = String(item.status || "").toUpperCase() === "INACTIVE";

              return (
                <tr key={item.id} className={isInativo ? "row-inactive" : ""}>
                  <td>{item.nome}</td>
                  <td>{item.email}</td>
                  <td>{renderizarStatus(item.status)}</td>
                  <td>{formatarDataBR(item.dataCriacao)}</td>
                  <td>
                    <div className="actions-cell">
                      <button
                        className="action-btn"
                        data-id={item.id}
                        data-action="editar"
                        onClick={() => onEdit?.(item.id)}
                      >
                        <span>Editar</span>
                      </button>

                      <button className="action-btn" data-id={item.id} data-action="extrato">
                        <span>Ver extrato</span>
                      </button>

                      <button className="action-btn" data-id={item.id} data-action="bancarios">
                        <span>Dados bancarios</span>
                      </button>

                      <button
                        className={`action-btn ${isInativo ? "action-btn-success" : "action-btn-danger"}`}
                        data-id={item.id}
                        data-action={isInativo ? "reativar" : "excluir"}
                        onClick={() => abrirConfirmacao(item)}
                      >
                        <span>{isInativo ? "Reativar" : "Excluir"}</span>
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="table-footer">
        <div id="usuariosInfo">{itens.length} licenciados encontrados</div>
      </div>

      <Modal
        open={Boolean(confirmacao)}
        title={confirmacao?.proximoStatus === "INACTIVE" ? "Confirmar exclusao" : "Confirmar reativacao"}
        onClose={fecharConfirmacao}
      >
        <div className="confirm-status-content">
          {confirmacao?.proximoStatus === "INACTIVE" ? (
            <p>
              O usuario <strong>{confirmacao?.item?.nome}</strong> sera desativado. O cadastro nao sera apagado, ficara
              riscado na lista e nao podera fazer login ate ser reativado.
            </p>
          ) : (
            <p>
              O usuario <strong>{confirmacao?.item?.nome}</strong> sera reativado e voltara a poder acessar a conta.
            </p>
          )}

          <div className="confirm-status-actions">
            <button type="button" className="action-btn" onClick={fecharConfirmacao} disabled={processando}>
              Cancelar
            </button>
            <button
              type="button"
              className={`action-btn ${confirmacao?.proximoStatus === "INACTIVE" ? "action-btn-danger" : "action-btn-success"}`}
              onClick={confirmarTrocaStatus}
              disabled={processando}
            >
              {processando ? "Processando..." : confirmacao?.proximoStatus === "INACTIVE" ? "Confirmar exclusao" : "Confirmar reativacao"}
            </button>
          </div>
        </div>
      </Modal>
    </section>
  );
};

export default ListaUsuarios;
